
export const GundemScreen = () => `
        <div id="gundem-screen" class="screen">
            <h2 class="screen-title">GÜNDEM SEÇİMİ</h2>
            <div class="difficulty-options"> <!-- Reusing styling -->
                <button class="gaddar-btn gundem-sub-btn" data-sub="turkiye">
                    <span>TÜRKİYE GÜNDEMİ</span>
                    <small>Yerel olaylar.</small>
                </button>
                <button class="gaddar-btn gundem-sub-btn" data-sub="dunya">
                    <span>DÜNYA GÜNDEMİ</span>
                    <small>Küresel olaylar.</small>
                </button>
            </div>
        </div>
`;
